<div class="cta-area ptb-100">
    <div class="container">
        <div class="cta-content">
            <div class="section-title mb-0">
                <h4>{{ 'cta.kicker' | translate }}</h4>
                <h2>{{ 'cta.title' | translate }}</h2>
                <p>{{ 'cta.text' | translate }}</p>
                <a (click)="onClick('contact')" class="btn btn-primary">{{ 'cta.contact' | translate }}</a>
                <a hidden (click)="onClick('work')" class="btn btn-primary view-work">Portafolio</a>
            </div>
        </div>
    </div>
</div>
